import { Controller } from "@hotwired/stimulus"

export default class TimezoneController extends Controller {
  static targets = ["input"]

  connect() {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      this.inputTarget.value = tz
    } catch (e) {
      console.error("Failed to detect timezone:", e)
      this.inputTarget.value = "UTC"
    }
  }
}
